export default function Footer() {
  return (
    <footer className="py-16 border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center gap-12">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-primary-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
              </svg>
            </div>
            <span className="text-2xl font-bold tracking-tight text-foreground">
              IGNISS
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8 text-sm font-medium text-muted-foreground">
            <a href="/shipping" className="hover:text-primary smooth-hover">Shipping Information</a>
            <a href="/returns" className="hover:text-primary smooth-hover">Returns Policy</a>
            <a href="/contact" className="hover:text-primary smooth-hover">Support Contact</a>
          </div>

          {/* Statement */}
          <p className="text-sm text-muted-foreground text-center max-w-md">
            IGNISS releases one product at a time. Once sold out, it is retired.
          </p>

          {/* Copyright */}
          <p className="text-xs luxury-caps text-muted-foreground">© 2026 IGNISS</p>
        </div>
      </div>
    </footer>
  )
}